import React from 'react';
import 'twin.macro';
import { Button } from '../button';
import { Input } from '../form';
import { Icon } from '../icon';
import { LoaderIcon } from 'icons';
import { useUnmounted } from '../common/hooks';
import { notifySuccess, notifyError } from '../notifications';

export const UserSettingUpdateForm = ({ params, update }) => {
  const unmounted = useUnmounted();

  const { formFields, formAction, formNotifications, pendingSubmit } = params;

  const submit = (e) => {
    e.preventDefault();
    update({ ...params, pendingSubmit: true });

    formAction(formFields.reduce((o, c) => ({ ...o, [c.formDataId]: c.inputValue }), {}))
      .then(() => {
        if (!unmounted.current) {
          update({
            ...params,
            formActive: false,
            pendingSubmit: false,
          });
          notifySuccess(formNotifications.success);
          params.getCurrentUser();
        }
      })
      .catch((e) => {
        if (!unmounted.current) {
          const errorMessage =
            e.response && e.response.data
              ? e.response.data.errors
                ? e.response.data.errors[0].Message
                : e.response.status === 403
                  ? `Je moet nog ${e.response.data} dagen wachten voordat je je reaguurdersnaam kan aanpassen.`
                  : formNotifications.danger
              : formNotifications.danger;
          update({ ...params, pendingSubmit: false });
          notifyError(errorMessage);
        }
      });
  };

  return (
    <form onSubmit={(e) => submit(e)} tw='flex w-full gap-3 items-center'>
      <div tw='flex-grow'>
        {formFields.map((field) => (
          <Input
            key={field.label}
            id={field.formDataId}
            type={field.type}
            label={field.description ? field.description : `Je ${field.label} aanpassen`}
            placeholder={field.description ? field.description : `Je nieuwe ${field.label}`}
            value={field.inputValue}
            requiredField={field.requiredField}
            onChange={(e) => {
              update({
                ...params,
                formFields: [
                  ...params.formFields.map((item) =>
                    item.label === field.label
                      ? {
                          ...item,
                          inputValue: e.target.value,
                        }
                      : { ...item },
                  ),
                ],
              });
            }}
          />
        ))}
      </div>
      <Button
        type='submit'
        label={
          !pendingSubmit ? (
            'aanpassen'
          ) : (
            <Icon Type={LoaderIcon} tw='animate-spin h-5' color='input-back' size='small' />
          )
        }
        primary
        disabled={!formFields[0].inputValue}
      />
    </form>
  );
};
